import React from 'react';

export const PaginationSelectContext = React.createContext({
  isOpen: false,
  setIsOpen: null,
  itemsPerPageValue: '',
  setItemsPerPageValue: null
});

export const PaginationSelectProvider = PaginationSelectContext.Provider;
export const PaginationSelectConsumer = PaginationSelectContext.Consumer;
export default PaginationSelectContext;
